import * as React from 'react';

import { IBrandColorValueCmykProps } from './types';

import * as s from './BrandColorValueCmyk.scss';

export const BrandColorValueCmyk = ({
	value,
}: IBrandColorValueCmykProps) => {
	return (
		<React.Fragment>
			{value.split(/\s+/).map((cmykComponent) => (
				<React.Fragment key={cmykComponent}>
					<span className={s.name}>
						{cmykComponent[0]}
					</span>

					<span className={s.value}>
						{cmykComponent.slice(1)}
						{' '}
					</span>
				</React.Fragment>
			))}
		</React.Fragment>
	);
};
